import { render, staticRenderFns } from "./TickerBlock.vue?vue&type=template&id=0b2a8168"
import script from "./TickerBlock.vue?vue&type=script&lang=js"
export * from "./TickerBlock.vue?vue&type=script&lang=js"
import style0 from "./TickerBlock.vue?vue&type=style&index=0&id=0b2a8168&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports